module.exports = __webpack_public_path__ + "img/logo.835593bb.png";